import * as $ from "jquery";

// ================================================================================
// Description
//
// This script pulls down data from a JSON file on the Fly CDN related to Connext
// plans, details, and pricing.  It then formats that data into HTML and inserts
// it into the static page: satellitepricing.scala.html.
// ================================================================================

// ================================================================================
// Initial page setup - Logic starts here
// ================================================================================

$("document").ready(function() {
	getPricingDetailsFromJsonFile().then((details: PricingDetailsV1) => {
		if (details != null) {
			insertPricingDetails(details);
			insertConnextPricingDetailsHtml();
		}
	});
});

// ================================================================================
// Constants and local variables
// ================================================================================

// These constants are set in satellitepricing.scala.html
declare var satelliteServicesPricingDetailsJsonUrl: string;
declare var flyGarminLoginUrl: string;

// The HTML IDs for the placeholder divs in satellitepricing.scala.html
const connextPricingIntroductionDivId = 'connext-pricing-intro';
const connextPricingDetailsDivId = 'connext-pricing-details';

// HTML to be inserted into the connext pricing details divs
var connextPricingIntroductionHtml = '';
var connextPricingDetailsHtml = '';

// ================================================================================
// Domain models
// ================================================================================

interface PricingFeatureV1 {
	title: string | null;
	description: string | null;
	descriptionBase64Encoded?: string;
	descriptionSuperscript: string | null;
	descriptionSubtextBase64Encoded: string | null;
}

interface PricingPlanV1 {
	color: string | null;
	title: string | null;
	titleSubtext: string | null;
	description: string | null;
	descriptionSubtext: string | null;
	features: PricingFeatureV1[] | null;
	priceAmount: string | null;
	priceUnits: string | null;
	priceSuperscript: string | null;
	priceDescription: string | null;
}

interface PricingCategoryV1 {
	title: string | null;
	deviceName: string | null;
	description: string | null;
	descriptionBase64Encoded: string | null;
	plans: PricingPlanV1[] | null;
}

interface PricingDetailsV1 {
	introductionTextBase64Encoded: string | null;
	categories: PricingCategoryV1[] | null;
}

// ================================================================================
// Get pricing details from JSON file on the CDN
// ================================================================================

function getPricingDetailsFromJsonFile(): Promise<PricingDetailsV1> {
	return new Promise<PricingDetailsV1>((resolve, reject) => {
		$.ajax({
			type: 'GET',
			url: `${satelliteServicesPricingDetailsJsonUrl}`,
			dataType: 'json',
			success: (details: PricingDetailsV1) => {
				resolve(details);
			},
			error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
				console.error(`${jqXHR.status} ${textStatus} ${errorThrown}`);
				reject();
			}
		});
	});
}

// ================================================================================
// Insert pricing details
// ================================================================================

function insertPricingDetails(details: PricingDetailsV1) {
	if (details.introductionTextBase64Encoded != null) {
		connextPricingIntroductionHtml += `${atob(details.introductionTextBase64Encoded)}`;
	}

	details.categories.forEach((category: PricingCategoryV1) => {
		insertPricingCategory(category);
	});
}

// ================================================================================
// Insert pricing category
// ================================================================================

function insertPricingCategory(category: PricingCategoryV1) {
	// Wrap category in border
	connextPricingDetailsHtml += `<fieldset>`

	// Display category title
	if (category.title != null) {
		connextPricingDetailsHtml += `<legend>${category.title}</legend>`;
	}

	// Display category description
	if (category.description != null) {
		connextPricingDetailsHtml += `<p class="mb-4">${category.description}</p>`;
	} else if (category.descriptionBase64Encoded != null) {
		connextPricingDetailsHtml += `<p class="mb-4">${atob(category.descriptionBase64Encoded)}</p>`;
	}


	connextPricingDetailsHtml += '<p class="col-4 mx-auto pb-5">';
	connextPricingDetailsHtml += `<a href="${flyGarminLoginUrl}" class="btn btn-outline-primary btn-block">SIGN INTO FLYGARMIN TO SIGN UP</a>`;
	connextPricingDetailsHtml += '</p>';

	// Display the plans within this category
	if (category.plans != null && category.plans.length > 0) {
		connextPricingDetailsHtml += '<div class="row">';

		category.plans.forEach((plan: PricingPlanV1) => {
			insertPricingPlan(plan);
		});

		connextPricingDetailsHtml += '</div>';
	}

	connextPricingDetailsHtml += `</fieldset>`
}

// ================================================================================
// Insert pricing plan
// ================================================================================

function insertPricingPlan(plan: PricingPlanV1) {

	// Card

	connextPricingDetailsHtml += '<div class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3">';
	connextPricingDetailsHtml += '<section class="card">';

	// --------------------------------------------------------------------------------

	// Card header

	connextPricingDetailsHtml += `<div class="card-header fly-pricing-card-header fly-pricing-card-header-${plan.color}">`;

	// Display plan title
	if (plan.title != null) {
		connextPricingDetailsHtml += `<h3 class="font-weight-bold mb-1">${plan.title}</h3>`;
	}

	// Display plan title subtext
	if (plan.titleSubtext != null) {
		connextPricingDetailsHtml += `<p class="mb-0">${plan.titleSubtext}</p>`;
	}

	connextPricingDetailsHtml += '</div>';

	// --------------------------------------------------------------------------------

	// Card body

	connextPricingDetailsHtml += '<div class="card-body">';

	// --------------------------------------------------------------------------------

	// Insert description

	connextPricingDetailsHtml += '<p class="lead">';

	// Display plan description
	if (plan.description != null) {
		connextPricingDetailsHtml += plan.description;
	}

	// Display plan description subtext
	if (plan.descriptionSubtext != null) {
		connextPricingDetailsHtml += `<small class="d-block font-weight-light">${plan.descriptionSubtext}</small>`;
	}

	connextPricingDetailsHtml += '</p>';

	// --------------------------------------------------------------------------------

	// Insert features

	plan.features.forEach((feature: PricingFeatureV1) => {
		insertPricingFeature(feature);
	});

	// --------------------------------------------------------------------------------

	// Insert price details

	connextPricingDetailsHtml += '<p class="lead">';

	// Display price amount
	if (plan.priceAmount != null) {
		connextPricingDetailsHtml += `<strong class="font-weight-bold">${plan.priceAmount}</strong> `;
	}

	// Display price units
	if (plan.priceUnits != null) {
		connextPricingDetailsHtml += plan.priceUnits;
	}

	// Display price superscript
	if (plan.priceSuperscript != null) {
		connextPricingDetailsHtml += `<sup>${plan.priceSuperscript}</sup>`;
	}

	connextPricingDetailsHtml += '</p>';

	// Display price description
	if (plan.priceDescription != null) {
		connextPricingDetailsHtml += `<p>${plan.priceDescription}</p>`;
	}

	// --------------------------------------------------------------------------------

	// End of card body

	connextPricingDetailsHtml += '</div>';

	// --------------------------------------------------------------------------------

	// Card footer

	connextPricingDetailsHtml += '<div class="card-footer bg-white border-top-0">';
	connextPricingDetailsHtml += '</div>';

	// --------------------------------------------------------------------------------

	// End of card

	connextPricingDetailsHtml += '</section>';
	connextPricingDetailsHtml += '</div>';
}

// ================================================================================
// Insert pricing feature
// ================================================================================

function insertPricingFeature(feature: PricingFeatureV1) {
	connextPricingDetailsHtml += '<p>';

	if (feature.title != null) {
		connextPricingDetailsHtml += `<strong>${feature.title}:</strong><br>`;
	}

	if (feature.description != null) {
		connextPricingDetailsHtml += `${feature.description}`;

		if (feature.descriptionSuperscript != null) {
			connextPricingDetailsHtml += `<sup>${feature.descriptionSuperscript}</sup>`
		}

		connextPricingDetailsHtml += `<br>`
	}

	if (feature.descriptionBase64Encoded != null) {
		connextPricingDetailsHtml += `${atob(feature.descriptionBase64Encoded)}`;

		if (feature.descriptionSuperscript != null) {
			connextPricingDetailsHtml += `<sup>${feature.descriptionSuperscript}</sup>`
		}

		connextPricingDetailsHtml += `<br>`
	}

	if (feature.descriptionSubtextBase64Encoded != null) {
		connextPricingDetailsHtml += `<small>${atob(feature.descriptionSubtextBase64Encoded)}</small>`;
	}

	connextPricingDetailsHtml += '</p>';
}

// ================================================================================
// Insert HTML into Connext Pricing Detail divs
// ================================================================================

function insertConnextPricingDetailsHtml() {
	$(`#${connextPricingIntroductionDivId}`).html(connextPricingIntroductionHtml);
	$(`#${connextPricingDetailsDivId}`).html(connextPricingDetailsHtml);
}
